import { getTranslate } from '@nx/translations'

import {
  ConnectionLostContainer,
  ConnectionLostTextContainer,
  RefreshButton,
  StyledWarningIcon,
  Subheading,
  Title,
} from './LostBiddingConnectionBanner.styles'
import translate from './LostBiddingConnectionBanner.translate.json'

const { text } = getTranslate(translate)

export const LostBiddingConnectionBanner = () => {
  return (
    <ConnectionLostContainer role="status">
      <StyledWarningIcon />
      <ConnectionLostTextContainer>
        <Title>{text('title')}</Title>
        <Subheading>{text('body')}</Subheading>
      </ConnectionLostTextContainer>
      <RefreshButton onClick={() => window.location.reload()}>
        {text('button')}
      </RefreshButton>
    </ConnectionLostContainer>
  )
}
